type Handler = (...args: any[]) => void;

export function createEventBus() {
  const listeners: Record<string, Handler[]> = {};

  return {
    $on(event: string, handler: Handler) {
      listeners[event] = listeners[event] || [];
      listeners[event].push(handler);
    },
    $off(event: string, handler: Handler) {
      listeners[event] = (listeners[event] || []).filter(listener => listener !== handler);
    },
    $emit(event: string, ...args: any[]) {
      (listeners[event] || []).forEach(handler => handler(...args));
    },
  };
}

export default createEventBus();
